import { styled, utilities } from '@creditas/stylitas';

export const InputContainer = styled.div`
  > div {
    margin-bottom: 0;
  }
  & > div:last-of-type input:disabled {
    color: #7a8888;
    &:not([value='']) {
      font-weight: 900;
      background: ${(props): string =>
        utilities.palette.color(props.theme, 'neutral01')};
    }
  }
`;

export const ErrorContainer = styled.div`
  margin-top: 5px;
`;
